import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HeaderTextService {
  private titulo: string = '';
  private nombre: string = '';
  private subtitulo: string = '';

  public helpRequested$ = new Subject<void>();

  requestHelp() {
      this.helpRequested$.next();
  }

  /**
   * Getter for titulo
   */
  getTitulo(): string {
    return this.titulo || '';
  }

  /**
   * Setea titulo basado en la ruta (como ya lo tenías)
   */
  setTitulo(route: Router, nombre?: string) {
    this.titulo = route.url;
    if (nombre) {
      this.nombre = nombre;
    }
  }

  /**
   * Setea el titulo manual (sin importar la ruta)
   */
  setTituloManual(nombre: string) {
    this.titulo = '';   // limpiamos ruta para que no interfiera
    this.nombre = nombre;
  }

  /**
   * Setea el subtitulo manual
   */
  setSubtitulo(subtitulo: string) {
    this.subtitulo = subtitulo;
  }

  /**
   * Getter para nombre (manual o asignado en setTitulo)
   */
  getNombre(): string {
    return this.nombre || '';
  }

  /**
   * Getter para subtitulo
   */
  getSubtitulo(): string {
    return this.subtitulo || '';
  }

  clear() {
    this.titulo = '';
    this.nombre = '';
    this.subtitulo = '';
  }
}
